import { Route, Routes } from '@angular/router'
import { ContactComponent } from 'src/app/features/pages/front-pages/contact/contact.component'
import { FaqComponent } from 'src/app/features/pages/front-pages/faq/faq.component'
import { FeaturesComponent } from 'src/app/features/pages/front-pages/features/features.component'
import { FrontPagesComponent } from 'src/app/features/pages/front-pages/front-pages.component'
import { HomeComponent } from 'src/app/features/pages/front-pages/home/home.component'
import { CookieManagementPolicyComponent } from './features/pages/front-pages/legal/cookie-management-policy/cookie-management-policy.component'
import { PersonalDataPolicyComponent } from './features/pages/front-pages/legal/personal-data-policy/personal-data-policy.component'
import { ProcessComponent } from './features/pages/front-pages/process/process.component'
import { TestStripeComponent } from './features/pages/front-pages/teststripe/teststripe.component'
import { OrderTrackingComponent } from 'src/app/features/pages/order/tracking/order-tracking.component'
import { Page500Component } from '@corporate-tailwind/error-page'
import { TestItsMeComponent } from './features/pages/front-pages/testitsme/testitsme.component'
import { TestItsMeUserInfoComponent } from './features/pages/front-pages/testitsme/testitsmeuserinfo.component'
import { OrderPageComponent } from './features/pages/order/order-page.component'
import { OrderWizardComponent } from './features/pages/order/wizard/_common/order-wizard.component'
import { OrderPaymentResultComponent } from './features/pages/order/wizard/_common/payment-result/payment-result.component'
import { PrintPageComponent } from './features/pages/print/print-page.component'
import { PrintOrderPageComponent } from './features/pages/print/order/print-order-page.component'
import { AuthenticationComponent } from './features/pages/authentication/authentication.component'
import { LegalPagesComponent } from './features/pages/front-pages/legal/legal-pages.component'
import { TermOfSaleComponent } from './features/pages/front-pages/legal/term-of-sale/term-of-sale.component'
import { ConfirmEmailOkComponent } from './features/pages/authentication/confirm-email/ok/confirm-email-ok.component'
import { ConfirmEmailKoComponent } from './features/pages/authentication/confirm-email/ko/confirm-email-ko.component'
import { ConfirmDeliveryComponent } from 'src/app/features/pages/authentication/confirm-delivery/confirm-delivery.component'

// Définition de l'interface pour les données de route
export interface AppRouteData {
    entete?: string
    label?: string
    icon?: string
    backgroundColor?: string
}
// --- 2. Définition du Type de Route Personnalisé ---
// Crée un type où la propriété 'data' est forcée à être de type AppRouteData
export type AppRoutes = Array<Route & { data?: AppRouteData }>

export const routes: Routes = [
    {
        path: '',
        component: FrontPagesComponent,
        children: [
            { path: '', component: HomeComponent },
            { path: 'features', component: FeaturesComponent },
            // { path: 'team', component: TeamComponent },
            { path: 'faq', component: FaqComponent },
            { path: 'contact', component: ContactComponent },
            { path: 'process', component: ProcessComponent },
            { path: 'teststripe', component: TestStripeComponent },
            { path: 'testitsme', component: TestItsMeComponent },
            { path: 'testitsmeuserinfo', component: TestItsMeUserInfoComponent },
        ]
    },
    {
        path: 'authentication',
        component: AuthenticationComponent,
        children: [
            // {path: '', component: SignInComponent},
            // {path: 'sign-up', component: SignUpComponent},
            // {path: 'forgot-password', component: ForgotPasswordComponent},
            // {path: 'reset-password', component: ResetPasswordComponent},
            {path: 'confirm-email-ok', component: ConfirmEmailOkComponent},
            {path: 'confirm-email-ko', component: ConfirmEmailKoComponent},
            // {path: 'lock-screen', component: LockScreenComponent},
            // {path: 'logout', component: LogoutComponent}
            { path: 'confirm-delivery/:token64', component: ConfirmDeliveryComponent }
        ]
    },
    {
        path: 'order-page',
        component: OrderPageComponent ,
        children: [
            { path: '', component: OrderWizardComponent },
            
            { path: 'tracking', component: OrderTrackingComponent },
            { path: 'payment-result', component: OrderPaymentResultComponent },

        ]
    },
    {
        path: 'print',
        component: PrintPageComponent ,
        children: [
            { path: '', component: PrintOrderPageComponent },
            { path: 'order', component: PrintOrderPageComponent },
            { path: 'payment-result', component: OrderPaymentResultComponent },

        ]
    },
    // {
    //     path: 'order',
    //     component: OrderComponent,
    //     children: []
    // },
    // {
    //     path: 'payment-finished',
    //     component: OrderComponent
    //     // loadComponent: () => import('src/app/features/pages/order/wizard/payment/order-wizard-payment.component').then(c => c.OrderWizardpaymentComponent),
    // },
    // {
    //     path: 'admin',
    //     component: AdminComponent,
    //     canActivate: [adminChildGuard],
    //     children: [
    //         { path: 'page1', component: AdminPage1Component },
    //         { path: 'page2', component: AdminPage2Component }
    //     ]
    // },
    {
        path: 'legal',
        component: LegalPagesComponent,
        children: [
            { path: '', component: PersonalDataPolicyComponent },
            { path: 'personal-data-policy', component: PersonalDataPolicyComponent },
            { path: 'cookie-management-policy', component: CookieManagementPolicyComponent },
            { path: 'term-of-sale', component: TermOfSaleComponent }
        ]
    },
    // {
    //     path: 'management',
    //     component: ManagementComponent,
    //     children: []
    // },
    // {
    //     path: 'dashbord',
    //     component: ManagementDashboardComponent,
    //     children: []
    // },
    // {
    //     path: 'legal',
    //     component: PersonalDataPolicyComponent,
    //     children: [ { path: 'personal-data-policy', component: PersonalDataPolicyComponent } ]
    // },
    // Routes d'erreur et de fallback
    { path: '500', component: Page500Component },

    // fallback pour toute URL inconnue
    { path: '**', redirectTo: '', pathMatch: 'full' }

    // 💡 FALLBACK : Redirige toute URL non reconnue vers la racine '/'
    // { path: '**', redirectTo: 'dashboard' }
]
